var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInquire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 10.1833C17.4993 5.60833 13.9493 2.5 9.99935 2.5C6.09102 2.5 2.49935 5.54167 2.49935 10.2333C1.99935 10.5167 1.66602 11.05 1.66602 11.6667V13.3333C1.66602 14.25 2.41602 15 3.33268 15H4.16602V9.91667C4.16602 6.69167 6.77435 4.08333 9.99935 4.08333C13.2243 4.08333 15.8327 6.69167 15.8327 9.91667V15.8333H9.16602V17.5H15.8327C16.7493 17.5 17.4993 16.75 17.4993 15.8333V14.8167C17.991 14.5583 18.3327 14.05 18.3327 13.45V11.5333C18.3327 10.95 17.991 10.4417 17.4993 10.1833Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 11.6667C7.95959 11.6667 8.33268 11.2936 8.33268 10.8333C8.33268 10.3731 7.95959 10 7.49935 10C7.03911 10 6.66602 10.3731 6.66602 10.8333C6.66602 11.2936 7.03911 11.6667 7.49935 11.6667Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 11.6667C12.9596 11.6667 13.3327 11.2936 13.3327 10.8333C13.3327 10.3731 12.9596 10 12.4993 10C12.0391 10 11.666 10.3731 11.666 10.8333C11.666 11.2936 12.0391 11.6667 12.4993 11.6667Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 9.19167C14.5994 6.81667 12.5327 5 10.0411 5C7.51607 5 4.7994 7.09167 5.01607 10.375C7.0744 9.53333 8.6244 7.7 9.06607 5.46667C10.1577 7.65833 12.3994 9.16667 14.9994 9.19167Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInquire);
export default __webpack_public_path__ + "static/media/icon_inquire.85a04c52a60b3eb5ce3a7ce6e04c51df.svg";
export { ForwardRef as ReactComponent };